import { APIEndpoints } from "constants/api-endpoints"
import { useMutation } from "react-query"
import { HttpRequest } from "services/_http"

export const useUploadFiles = (options?: any) => {
    const method = 'POST'
    return useMutation(({ data }: { data: FormData }) =>
        HttpRequest({
            url: `${APIEndpoints.Upload}`,
            method,
            data,
        }),
        options
    )
}
